class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.productId = this.dataset.productId;

    // Listen to variant change events
    document.addEventListener('variant:change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    if (!event.detail.variant) return;

    const sectionUrl = `${window.location.pathname}?section_id=${this.sectionId}&variant=${event.detail.variant.id}`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newDescription = html.querySelector('[data-product-description]');
        
        if (newDescription) {
          this.replaceWith(newDescription);
        }
      });
  }
}

if (!window.customElements.get('product-description')) {
  window.customElements.define('product-description', ProductDescription);
}
